import { ReportSearchModel } from '@/types';
import { EntityCardSize } from '@/components';
import ReportCardGD from './ReportCardGD';
import ReportCardStylus from './ReportCardStylus';

export interface ReportCardModel {
  data: ReportSearchModel;
  className?: string;
  size?: EntityCardSize;
  hideTitle?: boolean;
  hideViewed?: boolean;
  hideTopContent?: boolean;
  hideSaveToScrapbook?: boolean;
  onClick?: (e: React.MouseEvent, data: ReportSearchModel) => void;
}

const ReportCard = ({ data, ...props }: ReportCardModel) => {
  if (data.isGdReport) {
    return <ReportCardGD data={data} {...props} />;
  } else {
    return <ReportCardStylus data={data} {...props} />;
  }
};

export default ReportCard;
